import {
  AccountBalance as AccountBalanceIcon,
  Apartment as ApartmentIcon,
  Assessment as AssessmentIcon,
  Inventory as InventoryIcon,
  PointOfSale as PointOfSaleIcon,
  ShoppingCart as ShoppingCartIcon,
} from "@mui/icons-material";
import { PermissionEnum } from "./permission-enum";

export const topicPermissions = [
  {
    name: "Perusahaan",
    icon: <ApartmentIcon />,
    headers: ["Buat", "Lihat", "Ubah", "Hapus"],
    features: [
      {
        name: "Pengguna",
        permissions: [
          { action: PermissionEnum.CREATE_USERS },
          { action: PermissionEnum.READ_USERS },
          { action: PermissionEnum.UPDATE_USERS },
          {},
        ],
      },
      {
        name: "Peran",
        permissions: [
          { action: PermissionEnum.CREATE_ROLES },
          { action: PermissionEnum.READ_ROLES },
          { action: PermissionEnum.UPDATE_ROLES },
          {},
        ],
      },
      {
        name: "Perusahaan",
        permissions: [
          { action: PermissionEnum.CREATE_COMPANIES },
          { action: PermissionEnum.READ_COMPANIES },
          { action: PermissionEnum.UPDATE_COMPANIES },
          {},
        ],
      },
      {
        name: "Cabang Toko",
        permissions: [
          { action: PermissionEnum.CREATE_OUTLETS },
          { action: PermissionEnum.READ_OUTLETS },
          { action: PermissionEnum.UPDATE_OUTLETS },
          {},
        ],
      },
      {
        name: "Biaya",
        permissions: [
          { action: PermissionEnum.CREATE_EXPENSES },
          { action: PermissionEnum.READ_EXPENSES },
          { action: PermissionEnum.UPDATE_EXPENSES },
          {},
        ],
      },
      {
        name: "Kategori Biaya",
        permissions: [
          { action: PermissionEnum.CREATE_EXPENSE_CATEGORIES },
          { action: PermissionEnum.READ_EXPENSE_CATEGORIES },
          { action: PermissionEnum.UPDATE_EXPENSE_CATEGORIES },
          {},
        ],
      },
      {
        name: "Pencatatan Beban",
        permissions: [
          { action: PermissionEnum.CREATE_EXPENSE_ACCRUALS },
          { action: PermissionEnum.READ_EXPENSE_ACCRUALS },
          { action: PermissionEnum.UPDATE_EXPENSE_ACCRUALS },
          { action: PermissionEnum.DELETE_EXPENSE_ACCRUALS },
        ],
      },
      {
        name: "Kampanye Promosi",
        permissions: [
          { action: PermissionEnum.CREATE_PROMOTIONS },
          { action: PermissionEnum.READ_PROMOTIONS },
          { action: PermissionEnum.UPDATE_PROMOTIONS },
          { action: PermissionEnum.DELETE_PROMOTIONS },
        ],
      },
      {
        name: "Preferensi Akun",
        permissions: [
          {},
          {
            action:
              PermissionEnum.READ_ACCOUNTING_ACTION_CHART_OF_ACCOUNT_PREFERENCES,
          },
          {
            action:
              PermissionEnum.UPDATE_ACCOUNTING_ACTION_CHART_OF_ACCOUNT_PREFERENCES,
          },
        ],
      },
      {
        name: "Akun Default",
        permissions: [
          {},
          {
            action: PermissionEnum.READ_ACCOUNTING_ACTION_CHART_OF_ACCOUNT,
          },
        ],
      },
    ],
  },
  {
    name: "Persediaan",
    icon: <InventoryIcon />,
    headers: ["Buat", "Lihat", "Ubah", "Hapus"],
    features: [
      {
        name: "Kategori Produk",
        permissions: [
          { action: PermissionEnum.CREATE_PRODUCT_CATEGORIES },
          { action: PermissionEnum.READ_PRODUCT_CATEGORIES },
          { action: PermissionEnum.UPDATE_PRODUCT_CATEGORIES },
          {},
        ],
      },
      {
        name: "Satuan Ukuran",
        permissions: [
          { action: PermissionEnum.CREATE_UNIT_OF_MEASUREMENTS },
          { action: PermissionEnum.READ_UNIT_OF_MEASUREMENTS },
          { action: PermissionEnum.UPDATE_UNIT_OF_MEASUREMENTS },
          {},
        ],
      },
      {
        name: "Atribut Varian Produk",
        permissions: [
          { action: PermissionEnum.CREATE_PRODUCT_VARIANT_ATTRIBUTES },
          { action: PermissionEnum.READ_PRODUCT_VARIANT_ATTRIBUTES },
          { action: PermissionEnum.UPDATE_PRODUCT_VARIANT_ATTRIBUTES },
          {},
        ],
      },
      {
        name: "Produk",
        permissions: [
          { action: PermissionEnum.CREATE_PRODUCTS },
          { action: PermissionEnum.READ_PRODUCTS },
          { action: PermissionEnum.UPDATE_PRODUCTS },
          {},
        ],
      },
      {
        name: "Varian Produk",
        permissions: [
          { action: PermissionEnum.CREATE_PRODUCT_VARIANTS },
          { action: PermissionEnum.READ_PRODUCT_VARIANTS },
          { action: PermissionEnum.UPDATE_PRODUCT_VARIANTS },
          {},
        ],
      },
      {
        name: "Harga Retail",
        permissions: [
          {},
          {},
          { action: PermissionEnum.UPDATE_PRODUCT_RETAIL_PRICE },
          {},
        ],
      },
      {
        name: "Harga Distributor",
        permissions: [
          {},
          {},
          { action: PermissionEnum.UPDATE_PRODUCT_DISTRIBUTOR_PRICE },
          {},
        ],
      },
      {
        name: "Gudang",
        permissions: [
          { action: PermissionEnum.CREATE_WAREHOUSES },
          { action: PermissionEnum.READ_WAREHOUSES },
          { action: PermissionEnum.UPDATE_WAREHOUSES },
          {},
        ],
      },
      {
        name: "Penyesuaian Stok",
        permissions: [
          { action: PermissionEnum.CREATE_STOCK_ADJUSTMENTS },
          { action: PermissionEnum.READ_STOCK_ADJUSTMENTS },
          { action: PermissionEnum.UPDATE_STOCK_ADJUSTMENTS },
          { action: PermissionEnum.DELETE_STOCK_ADJUSTMENTS },
        ],
      },
    ],
  },
  {
    name: "Pembelian",
    icon: <ShoppingCartIcon />,
    headers: ["Buat", "Lihat", "Ubah"],
    features: [
      {
        name: "Pesanan Pembelian Bulk",
        permissions: [
          { action: PermissionEnum.CREATE_PURCHASE_ORDERS_STANDARD },
          { action: PermissionEnum.READ_PURCHASE_ORDERS_STANDARD },
          { action: PermissionEnum.UPDATE_PURCHASE_ORDERS_STANDARD },
        ],
      },
      {
        name: "Pesanan Pembelian Lab.",
        permissions: [
          { action: PermissionEnum.CREATE_PURCHASE_ORDERS_LAB },
          { action: PermissionEnum.READ_PURCHASE_ORDERS_LAB },
          { action: PermissionEnum.UPDATE_PURCHASE_ORDERS_LAB },
        ],
      },
      {
        name: "Penerimaan Barang",
        permissions: [
          { action: PermissionEnum.CREATE_GOODS_RECEIPTS },
          { action: PermissionEnum.READ_GOODS_RECEIPTS },
          { action: PermissionEnum.UPDATE_GOODS_RECEIPTS },
        ],
      },
      {
        name: "Faktur Pembelian",
        permissions: [
          { action: PermissionEnum.CREATE_PURCHASE_INVOICES },
          { action: PermissionEnum.READ_PURCHASE_INVOICES },
          { action: PermissionEnum.UPDATE_PURCHASE_INVOICES },
        ],
      },
      {
        name: "Uang Muka Pembelian",
        permissions: [
          { action: PermissionEnum.CREATE_PURCHASE_DOWN_PAYMENTS },
          { action: PermissionEnum.READ_PURCHASE_DOWN_PAYMENTS },
          { action: PermissionEnum.UPDATE_PURCHASE_DOWN_PAYMENTS },
        ],
      },
      {
        name: "Pembayaran Pembelian",
        permissions: [
          { action: PermissionEnum.CREATE_PURCHASE_PAYMENTS },
          { action: PermissionEnum.READ_PURCHASE_PAYMENTS },
          { action: PermissionEnum.UPDATE_PURCHASE_PAYMENTS },
        ],
      },
      {
        name: "Retur Pembelian",
        permissions: [
          { action: PermissionEnum.CREATE_PURCHASE_RETURNS },
          { action: PermissionEnum.READ_PURCHASE_RETURNS },
          { action: PermissionEnum.UPDATE_PURCHASE_RETURNS },
        ],
      },
      {
        name: "Pemasok",
        permissions: [
          { action: PermissionEnum.CREATE_SUPPLIERS },
          { action: PermissionEnum.READ_SUPPLIERS },
          { action: PermissionEnum.UPDATE_SUPPLIERS },
        ],
      },
      {
        name: "Kategori Pemasok",
        permissions: [
          { action: PermissionEnum.CREATE_SUPPLIER_CATEGORIES },
          { action: PermissionEnum.READ_SUPPLIER_CATEGORIES },
          { action: PermissionEnum.UPDATE_SUPPLIER_CATEGORIES },
        ],
      },
      {
        name: "Syarat Pembayaran",
        permissions: [
          { action: PermissionEnum.CREATE_PAYMENT_TERMS },
          { action: PermissionEnum.READ_PAYMENT_TERMS },
          { action: PermissionEnum.UPDATE_PAYMENT_TERMS },
        ],
      },
    ],
  },
  {
    name: "Penjualan",
    icon: <PointOfSaleIcon />,
    headers: ["Buat", "Lihat", "Ubah", "Hapus"],
    features: [
      {
        name: "Permintaan Penjualan",
        permissions: [
          {},
          {
            action: PermissionEnum.READ_SALES_REQUESTS,
          },
          {},
          {},
        ],
      },
      {
        name: "Pesanan Penjualan",
        permissions: [
          { action: PermissionEnum.CREATE_SALES_ORDERS },
          { action: PermissionEnum.READ_SALES_ORDERS },
          { action: PermissionEnum.UPDATE_SALES_ORDERS },
          { action: PermissionEnum.VOID_SALES_ORDERS },
        ],
      },
      {
        name: "Uang Muka Penjualan",
        permissions: [
          { action: PermissionEnum.CREATE_SALES_DOWN_PAYMENTS },
          { action: PermissionEnum.READ_SALES_DOWN_PAYMENTS },
          { action: PermissionEnum.UPDATE_SALES_DOWN_PAYMENTS },
          {},
        ],
      },
      {
        name: "Pengiriman",
        permissions: [
          { action: PermissionEnum.CREATE_DELIVERY_ORDERS },
          { action: PermissionEnum.READ_DELIVERY_ORDERS },
          { action: PermissionEnum.UPDATE_DELIVERY_ORDERS },
          {},
        ],
      },
      {
        name: "Faktur Penjualan",
        permissions: [
          { action: PermissionEnum.CREATE_SALES_INVOICES },
          { action: PermissionEnum.READ_SALES_INVOICES },
          { action: PermissionEnum.UPDATE_SALES_INVOICES },
          {},
        ],
      },
      {
        name: "Pembayaran Penjualan",
        permissions: [
          { action: PermissionEnum.CREATE_SALES_PAYMENTS },
          { action: PermissionEnum.READ_SALES_PAYMENTS },
          { action: PermissionEnum.UPDATE_SALES_PAYMENTS },
          {},
        ],
      },
      {
        name: "Retur Penjualan",
        permissions: [
          { action: PermissionEnum.CREATE_SALES_RETURNS },
          { action: PermissionEnum.READ_SALES_RETURNS },
          { action: PermissionEnum.UPDATE_SALES_RETURNS },
        ],
      },
      {
        name: "Metode Pembayaran",
        permissions: [
          { action: PermissionEnum.CREATE_PAYMENT_METHODS },
          { action: PermissionEnum.READ_PAYMENT_METHODS },
          { action: PermissionEnum.UPDATE_PAYMENT_METHODS },
          {},
        ],
      },
      {
        name: "Pelanggan",
        permissions: [
          { action: PermissionEnum.CREATE_CUSTOMERS },
          { action: PermissionEnum.READ_CUSTOMERS },
          { action: PermissionEnum.UPDATE_CUSTOMERS },
          {},
        ],
      },
    ],
  },
  {
    name: "Shift Kasir",
    icon: <PointOfSaleIcon />,
    headers: ["Lihat", "Buka", "Tutup", "Menyetujui"],
    features: [
      {
        name: "Shift Kasir",
        permissions: [
          { action: PermissionEnum.READ_CASH_DRAWER_SHIFTS },
          { action: PermissionEnum.OPEN_CASH_DRAWER_SHIFTS },
          { action: PermissionEnum.CLOSE_CASH_DRAWER_SHIFTS },
          { action: PermissionEnum.ACKNOWLEDGE_CASH_DRAWER_SHIFTS },
        ],
      },
    ],
  },
  {
    name: "Buku Besar",
    icon: <AccountBalanceIcon />,
    headers: ["Buat", "Lihat", "Ubah", "Hapus"],
    features: [
      {
        name: "Template Akun Perkiraan",
        permissions: [
          { action: PermissionEnum.CREATE_CHART_OF_ACCOUNTS },
          { action: PermissionEnum.READ_CHART_OF_ACCOUNTS },
          { action: PermissionEnum.UPDATE_CHART_OF_ACCOUNTS },
          { action: PermissionEnum.DELETE_CHART_OF_ACCOUNTS },
        ],
      },
      {
        name: "Akun Perkiraan Outlet",
        permissions: [
          { action: PermissionEnum.CREATE_OUTLET_CHART_OF_ACCOUNTS },
          { action: PermissionEnum.READ_OUTLET_CHART_OF_ACCOUNTS },
          { action: PermissionEnum.UPDATE_OUTLET_CHART_OF_ACCOUNTS },
          { action: PermissionEnum.DELETE_OUTLET_CHART_OF_ACCOUNTS },
        ],
      },
      {
        name: "Jurnal Umum",
        permissions: [
          { action: PermissionEnum.CREATE_JOURNAL_VOUCHERS },
          { action: PermissionEnum.READ_JOURNAL_VOUCHERS },
          { action: PermissionEnum.UPDATE_JOURNAL_VOUCHERS },
          { action: PermissionEnum.DELETE_JOURNAL_VOUCHERS },
        ],
      },
      {
        name: "Pembayaran",
        permissions: [
          { action: PermissionEnum.CREATE_OTHER_PAYMENTS },
          { action: PermissionEnum.READ_OTHER_PAYMENTS },
          { action: PermissionEnum.UPDATE_OTHER_PAYMENTS },
          { action: PermissionEnum.DELETE_OTHER_PAYMENTS },
        ],
      },
    ],
  },
  {
    name: "Laporan",
    icon: <AssessmentIcon />,
    headers: ["Lihat"],
    features: [
      {
        name: "Penjualan",
        permissions: [{ action: PermissionEnum.READ_SALES_ORDER_REPORT }],
      },
      {
        name: "Penerimaan",
        permissions: [
          { action: PermissionEnum.READ_SALES_ORDER_PAYMENT_REPORT },
        ],
      },
      {
        name: "Biaya",
        permissions: [{ action: PermissionEnum.READ_EXPENSE_REPORT }],
      },
      {
        name: "Penjualan Produk Varian",
        permissions: [
          { action: PermissionEnum.READ_SALES_ORDER_PRODUCT_REPORT },
        ],
      },
      {
        name: "HPP",
        permissions: [
          { action: PermissionEnum.READ_COST_OF_GOODS_SOLD_REPORT },
        ],
      },
      {
        name: "Nilai Persediaan",
        permissions: [
          { action: PermissionEnum.READ_INVENTORY_VALUE_REPORT },
        ],
      },
    ],
  },
];
